<template>
    <div :style="style">
        <v-chart :options="pie" />
    </div>
</template>
<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/pie"; //环形图、饼状图
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

const clientWidth = document.body.clientWidth;

export default {
    name:'EPie',
    props:['size','dataSource',"name"],
    components:{
        'v-chart':ECharts,
    },
    data(){
        return{
            data:{
                series:[],
                sum:0
            },
            
            pieStyle:{
                width:(clientWidth - 300)/2 +'px',
                minWidth:530 + 'px',
                height:260 +'px',  
            }
        }
    },
    computed:{
        pie(){
	        if(this.dataSource.length==0){
                return;
            }
            this.data.series = this.dataSource;
            this.data.sum = 0;
            for(let i = 0; i <this.data.series.length; i++){
                this.data.sum += parseFloat(this.data.series[i].value);
            }
            let maxLength = this.nameLength(this.data.series);
            const that = this
            let option = {
                color:['#1890FF','#13C2C2','#2FC25B','#FACC14','#8543E0','#ff186e'],
                tooltip: {
                    trigger: 'item',
                    formatter: "{a} <br/>{b}: {c} ({d}%)"
                },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    icon:'circle',
                    padding:[15,20],
                    itemHeight:8,
                    itemWidth:20,
                    formatter:function(name){
                        const sum = that.data.sum;
                        let per = '';
                        let num = '';
                        for(let i=0;i<that.data.series.length;i++){
                            let name1 = that.data.series[i].name;
                            if(name1 === name) {
                                let val = that.data.series[i].value;
                                per = (val / sum * 100).toFixed(2) + '%';
                                num = val;
                                const j = maxLength - name.length;
                                for (let i = 0; i < j; i++){
                                    name = name.concat('　');
                                }
                            }
                        }
                        let arr = ["{a|"+name+"}","{b|"+"|"+"}","{c|"+per+"}","{d|"+num+"}"];
                        return arr.join("")

                    },
                    textStyle:{
                        rich:{
                            a:{
                                fontSize:14,
                                padding:10,
                                fontFamily: 'MicrosoftYaHei, 微软雅黑',
                                fontWeight: 400,
                                fontStyle: 'normal',
                                color: "#3BA1FF"
                            },
                            b:{
                                fontSize:14,
                                color:"rgba(233, 233, 233, 1)"
                            },
                            c: {
                                fontSize:14,
                                padding: [0,0,0,20],
                                color:"#666"
                            },
                            d: {
                                fontSize:14,
                                padding: [0,0,0,20],
                                color:"#333"
                            }
                        },

                        lineHeight:26,
                    },
                    
                },
                series: [
                    {
                        name:this.name,
                        type:'pie',
                        radius: [75, 100],
                        center:['75%', '45%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                show: true,
                                formatter: [
                                    '{a|{a}}',
                                    '{c|{c}}'
                                ].join('\n'),

                                rich:{
                                    a:{
                                        color:'#929292',
                                        fontSize:16,
                                        lineHeight:30,
                                    },
                                    c:{
                                        color:'#272727',
                                        fontSize:24,
                                        fontWeight:500,
                                        lineHeight:26,
                                    }
                                }
                            }
                        },
                        itemStyle:{
                            borderWidth:5,
                            borderColor:'#fff'
                        },      
                        data:this.data.series,
                    }
                ]
            };
            return option;
        },
        style(){
            return this.size ? this.size : this.pieStyle;
        }
    },
    methods:{
        nameLength(data){
            let maxLength = data[0].name.length;
            for(let i = 0; i < data.length; i++){
                maxLength = maxLength > data[i].name.length ? maxLength : data[i].name.length;
            }
            return maxLength;
        }
    }
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
</style>